// Gezet bij het inloggen; zolang deze staat controleert PolicyGate de acceptatie
export const POLICY_CHECK_KEY = "policy_check";

// Verwijdert alle sessiegegevens uit localStorage (gebruikt bij logout)
export function clearSession() {
  ["token", "organization_id", "company", "org_type", "role", "username", "avatar", "multicompany", "email",
    "daycounters", "monthcounters", "scoreCache_today", "scoreCache_month", "scoreCache_date",
    "impersonating", "real_organization_id", "real_company", "real_role", POLICY_CHECK_KEY]
    .forEach(k => localStorage.removeItem(k));
}
